import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=5724012c&"
import script from "./Item.vue?vue&type=script&lang=js&"
export * from "./Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5724012c')) {
      api.createRecord('5724012c', component.options)
    } else {
      api.reload('5724012c', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=5724012c&", function () {
      api.rerender('5724012c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/estimates/Item.vue"
export default component.exports